/* global axios */
import ApiClient from './ApiClient';

class FiltersAPI extends ApiClient {
  constructor() {
    super('filters', { accountScoped: true });
  }

  getFilters() {
    return axios.get(this.url);
  }

  getBuckets(filterId, params = {}) {
    return axios.get(`${this.url}/${filterId}/buckets`, { params });
  }

  getBucketCounts(filterId, params = {}) {
    return axios.get(`${this.url}/${filterId}/bucket_counts`, { params });
  }

  getBucketContacts(filterId, bucketKey, params = {}) {
    return axios.get(
      `${this.url}/${filterId}/buckets/${encodeURIComponent(bucketKey)}/contacts`,
      { params }
    );
  }

  getBucketConversations(filterId, bucketKey, params = {}) {
    return axios.get(
      `${this.url}/${filterId}/buckets/${encodeURIComponent(bucketKey)}/conversations`,
      { params }
    );
  }
}

export default new FiltersAPI();
